
















































import { Component, Vue, Prop, Inject } from "vue-property-decorator";
import { IGatewayProvider } from "@/models/gateways";
import {
  IOAuthProvider,
  IOAuthProviderMethods
} from "@/models/providers/oauth";

@Component
export default class AddOAuthTokenMessage extends Vue {
  @Inject("oauthProvider")
  public oauthProviderFunc!: () => IOAuthProvider;
  @Inject({ from: "oauthProviderMethods" })
  public readonly $oauthProviderMethods!: IOAuthProviderMethods;

  // Props
  @Prop({ required: true })
  public readonly provider!: IGatewayProvider["name"];
  @Prop({ default: false })
  public readonly isProcessing!: boolean;

  // Getters
  public get oauthProvider() {
    return this.oauthProviderFunc();
  }

  // Methods
  public initNewAuthAuthorization({ sandbox }) {
    this.$oauthProviderMethods.initNewAuthAuthorization({
      sandbox
    });
  }
}
